module.exports = __webpack_public_path__ + "static/media/129.3c302cc8.png";